import * as React from 'react';
import { Link } from 'react-router-dom';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import * as Site from '../../shared/Site';
import { Translate } from '../../shared/LanguageService';
import * as ProductProperties from '../../shared/ProductProperties';



interface IProductPropertiesIconsProps {
    properties: any[];
    site?: number;
    otherOrderId?: number;
}

interface IVisibleIcon {
    property: number;
    icon?: string;
    IconComponent?: React.ElementType;
}

const Icon = (props: {
    icon?: string;
    IconComponent?: React.ElementType;
    className: string;
    title: string;
    otherOrderId?: number;
}) => {
    const { IconComponent } = props;

    if (props.icon === 'straighten' && props.otherOrderId) {
        return (
            <Link
                className="btn btn-default btn-property"
                to={`/orders/${props.otherOrderId}#basic`}
            >
                <i
                    title={props.title}
                    key={props.icon}
                    className={'material-icons ' + props.className}
                >
                    {props.icon}
                </i>
            </Link>
        );
    }

    return (
        <i
            title={props.title}
            key={props.icon + '-' + props.otherOrderId}
            className={'material-icons ' + props.className}
        >
            {IconComponent ? <IconComponent fontSize="inherit" /> : props.icon}
        </i>
    );
};

const ProductPropertiesIcons = (props: IProductPropertiesIconsProps) => {
    let visibleIcons: IVisibleIcon[] = [
        { property: 2, icon: 'cloud_off' } /* Blue sky */,
        { property: 8, icon: 'whatshot' } /* early delivery */,
        { property: 11, icon: 'flash_on' } /* express */,
        { property: 12, icon: 'flash_on' } /* express weekend */,
        { property: 19, icon: 'videocam' } /* Film */,
        { property: 21, icon: 'landscape' } /* Height */,
        { property: 24, icon: 'image' } /* Interior blue sky */,
        { property: 27, icon: 'straighten' } /* Measured */,
        { property: 62, icon: 'text_fields' } /* Text */,
        { property: 100, icon: 'replay' } /* undo-alt */,
        { property: 64, icon: '3d_rotation' } /* matterport */,
        { property: 70, icon: 'brightness_4' } /* Day-To-Dusk */,
        { property: ProductProperties.SoMeFilm, icon: 'smartphone' } /* SoMe film */,
        { property: ProductProperties.Visualization, IconComponent: AutoFixHighIcon }
    ];

    return (
        <span className="property-icons">
            {props.properties &&
                props.properties
                    .filter((x: any) => visibleIcons.find((p) => p.property === x.value))
                    .map((x: any) => {
                        const visibleIcon = visibleIcons.find((p) => p.property === x.value);
                        return {
                            icon: visibleIcon.icon,
                            IconComponent: visibleIcon.IconComponent,
                            className: x.displayName.replace('product-property/', ''),
                            title: Translate(x.displayName)
                        };
                    })
                    .map((x: any, i: number) => (
                        <Icon
                            key={`icon-${i}`}
                            icon={x.icon}
                            IconComponent={x.IconComponent}
                            className={x.className}
                            title={x.title}
                            otherOrderId={props.otherOrderId}
                        />
                    ))}
            {props.site === Site.SE360 && <i className="se360-label">SE360</i>}
            {props.site === Site.Scandphotos && <i className="scandphotos-label">Scandphotos</i>}
        </span>
    );
};

export default ProductPropertiesIcons;
